import { formatPrice } from '@fshr/shared';

export const handlePriceFormat = ({
	amount = 0,
	currencyCode = 'USD',
}: {
	amount?: number;
	currencyCode?: string;
}): string => {
	try {
		const formattedPrice = formatPrice({
			currencyCode,
			value: amount,
		});

		if (typeof formattedPrice === 'string') {
			return formattedPrice;
		}

		return '';
	} catch (error) {
		console.log(error);
		return '';
	}
};
